import { useEffect } from "react";
import { useMap, useMapsLibrary } from "@vis.gl/react-google-maps";

/// Return lat lng altitude
const SelectLocation = ({ onSelected }) => {
  const map = useMap();
  const mapLibCore = useMapsLibrary("core");

  useEffect(() => {
    var listener = map.addListener("click", (e) => {
      if (onSelected) {
        var location = null;
        if (e.latLng) {
          try {
            location = new mapLibCore.LatLngAltitude(e.latLng);
          } catch (error) {
            console.warn("%c%s", "background-color:pink", error);
          }
        }
        onSelected(location, e);
      }
    });

    return () => {
      if (listener) {
        listener.remove();
      }
    };
  }, []);
  return null;
};

export default SelectLocation;
